export type AuditQuery = "detail" | "threads"

export function queriesToResync(
  promptSha: string | undefined,
  threadsSha: string | undefined,
  fetching: boolean,
): AuditQuery[] {
  if (fetching || !promptSha || !threadsSha || promptSha === threadsSha) return []
  return ["detail", "threads"]
}
